import {IDischargeModel} from '../api/api.types';
import {IDischargeChartPoint} from './discharge.types';

export function getDischargeValue(waterLevel:number, dischargeModel:IDischargeModel) {
  return dischargeModel.paramC *
      Math.pow(waterLevel + dischargeModel.paramA, dischargeModel.paramB);
}

export function getDischargePoints(minWaterLevel:number,
                                   maxWaterLevel:number,
                                   dischargeModel:IDischargeModel,
                                   resolution:number):Array<IDischargeChartPoint> {
  const range = maxWaterLevel - minWaterLevel;
  const step = range / resolution;
  const points:Array<IDischargeChartPoint> = [];
  for (let waterLevel = minWaterLevel; waterLevel < maxWaterLevel; waterLevel += step) {
    points.push({
      discharge: getDischargeValue(waterLevel, dischargeModel),
      waterLevel: waterLevel
    });
  }
  return points;
}



/** WEBPACK FOOTER **
 ** ./app/discharge/utils.ts
 **/